// extracted by mini-css-extract-plugin
module.exports = {"goTopButtonWrapper":"_2DFnM","fixed":"_3L0pZ","goTopButton":"_2zr5R","goTopArrow":"_1xkO8"};